let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hnzC4")).then(() => parcelRequire('d0ck0'));